<template>
  <div
    class="admin-modal-window"
    :class="{ 'full-screen': isFullScreen }"
    :style="[{ display: props.show ? 'block' : 'none' }]"
  >
    <!-- Картинка крестика-->
    <img
      class="close"
      src="/images/close.png"
      @click="emit('close')"
    />

    <!-- Картинка полного экрана-->
    <img
      class="close"
      src="/images/admin_panel/fullscreen.svg"
      alt=""
      @click="toggleFullScreen"
    />
    <!-- <template v-if="!Object.values(adminData).length">
      <div style="margin-top: 30%">
        <preloader />
      </div>
    </template> -->
    <template v-if="error">
      <div
        class="text-center"
        style="margin-top: 30%"
      >
        У пользователя
        <span style="color: #0000ff">{{ adminData.login }}</span>
        нет прав администратора.
      </div>
    </template>
    <div
      v-else
      class="admin-content"
      :style="{ display: props.show ? 'flex' : 'none' }"
    >
      <div
        class="container-fluid"
        style="margin-top: 20px"
      >
        <div class="row header">
          <button
            type="button"
            class="btn btn-primary config-btn-primary btn-sm"
            @click="showModalHandler('add-organization')"
          >
            Создать организацию
          </button>
          <button
            type="button"
            class="btn btn-primary config-btn-primary btn-sm my-m-2"
            @click="showModalHandler('add-user')"
          >
            Создать пользователя
          </button>
          <div class="flex">
            <button
              class="btn btn-outline-secondary btn-sm my-m-2"
              @click="refreshHandler"
            >
              Обновить
            </button>
            <img
              class="my-btn admin_panel mr-4 my-m-2 ml-2 cursor-pointer"
              id="logout"
              src="/images/logout.svg"
              alt=""
              @click="showModalHandler('admin-logout-modal')"
            />
          </div>
          <div class="flex">
            <span class="my-header-info"> &nbsp;| Вы вошли как &nbsp; </span>
            <div
              v-if="!adminData.userLogin"
              class="d-flex align-items-center"
            >
              <spin-loader
                :width="15"
                :height="15"
              />
            </div>
            <span
              v-else
              class="my-btn login-text my-header-info cursor-pointer"
              @click="showModalHandler('user-info')"
            >
              {{ adminData.userLogin }}
            </span>
          </div>
          <span class="my-header-info">
            <template v-if="adminData.main_admin">
              &nbsp;| Размер БД: {{ adminData.db_size }}
            </template>
          </span>

          <button class="btn btn-primary config-btn-primary btn-sm my-m-2" @click="showModalHandler('recalculate')">Пересчет объектов</button>
        </div>
        <hr />
        <span v-if="formInfo">{{ formInfo }}</span>
        <div class="row admin-table-wrapper" :class="{ 'both-open': bothAccordionsOpen }">
          <div
            class="col-12"
            style="max-width: 5000px; width: 5000px; overflow: auto;"
          >
            <div class="d-flex justify-content-between align-items-center" style="height: 40px;">
              <h6
                class="table-name my-btn pb-1 accordion__title m-0"
                @click="toggleAccordion('users')"
              >
                <span>Таблица пользователей</span>
              </h6>
              <input
                v-model="userSearch"
                type="text"
                placeholder="Поиск по логину"
                class="form-control search-input"
                :class="{'d-none': isAccordionClosed.users}"
                style="width: 250px; height: 30px; font-size: 14px;"
              />
            </div>
            <div
              v-if="!adminData.usersData"
              class="d-flex justify-content-center"
            >
              <spin-loader
                :width="50"
                :height="50"
              />
            </div>
            <div
              v-else
              class="my-toggle accordion__body"
              :class="{ closed: isAccordionClosed.users, large: !isAccordionClosed.users && isAccordionClosed.organizations }"
              id="users-table"
            >
              <ui-table
                :user-role="adminData.userRole"
                :is-organization="false"
                :data="adminData"
                :contractors="contractorsData"
                :search-value="userSearch"
                @edit="editHandler"
              />
            </div>
          </div>
          <div
            class="col-12"
            style="max-width: 5000px; width: 5000px; overflow: auto;"
          >
            <div class="d-flex justify-content-between align-items-center" style="height: 40px;">
              <h6
                class="table-name my-btn pb-1 accordion__title m-0"
                @click="toggleAccordion('organizations')"
              >
                <span>Таблица организаций</span>
              </h6>
              <input
                v-model="organizationSearch"
                type="text"
                placeholder="Поиск по логину"
                class="form-control search-input"
                :class="{'d-none': isAccordionClosed.organizations}"
                style="width: 250px; height: 30px; font-size: 14px;"
              />
            </div>
            <div
              v-if="!adminData.organizationsData"
              class="d-flex justify-content-center"
            >
              <spin-loader
                :width="50"
                :height="50"
              />
            </div>
            <div
              v-else
              class="my-toggle accordion__body"
              :class="{ closed: isAccordionClosed.organizations, large: !isAccordionClosed.organizations && isAccordionClosed.users }"
              id="orgaizations-table"
            >
              <div>
                <ui-table
                  :user-role="adminData.userRole"
                  :is-organization="true"
                  :data="adminData"
                  :contractors="contractorsData"
                  :search-value="organizationSearch"
                  @edit="editHandler"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <ui-admin-form
        :create="true"
        v-if="showModal === 'add-user'"
        :data="adminData"
        :contractors="contractorsData"
        :is-organization="false"
        :action="'create'"
        @close="showModal = ''"
        @refresh="refreshHandler"
        @form-info="setFormInfo"
      />
      <ui-admin-form
        :create="true"
        v-if="showModal === 'add-organization'"
        :data="adminData"
        :contractors="contractorsData"
        :is-organization="true"
        :action="'create'"
        @close="showModal = ''"
        @refresh="refreshHandler"
        @form-info="setFormInfo"
      />
      <ui-admin-form
        :edit="true"
        v-if="showModal === 'edit-user'"
        :data="adminData"
        :contractors="contractorsData"
        :is-organization="editingOrganization"
        :action="'edit'"
        @close="showModal = ''"
        @refresh="refreshHandler"
        @form-info="setFormInfo"
      />
      <admin-logout-modal
        :show="showModal === 'admin-logout-modal'"
        :login="adminData.userLogin"
        @close="showModal = ''"
        @to-monitoring="logoutModalHandler('toMonitoring')"
        @logout="logoutModalHandler('logout')"
      />
      <user-info
        :show="showModal === 'user-info'"
        :login="adminData.userLogin"
        :sender-rights="adminData.senderRights"
        @close="showModal = ''"
      />
      <recalculate-popup v-if="showModal === 'recalculate'" @close="showModal = ''"/>
      <div
        v-if="showModal === 'messenger-settings'"
        class="messenger-settings-overlay"
        @click="showModal = ''"
      >
        <div class="messenger-settings-modal" @click.stop>
          <img
            class="close"
            src="/images/close.png"
            @click="showModal = ''"
            style="position: absolute; top: 5px; right: 15px; z-index: 1000"
          />
          <div class="messenger-settings-modal__header">
            <h3>Настройки уведомлений в MAX</h3>
          </div>
          <div class="messenger-settings-modal__body">
            <notifications-settings
              type="admin"
              v-model="editingMessengerRow.messenger"
            />
          </div>
          <div class="messenger-settings-modal__footer">
            <button
              class="btn btn-primary config-btn-primary"
              :disabled="isSavingMessenger"
              @click="saveMessengerSettings"
            >
              {{ isSavingMessenger ? 'Сохранение...' : 'Изменить' }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { inject, onMounted, ref, watch, computed } from 'vue';

import Preloader from '../Components/Preloader.vue';
import SpinLoader from '../Components/SpinLoader.vue';
import AdminLogoutModal from './modals/AdminLogoutModal.vue';
import UserInfo from './modals/UserInfo.vue';
import UiAdminForm from './modals/UiAdminForm.vue';
import UiTable from './modals/UiTable.vue';
import RecalculatePopup from './modals/RecalculatePopup.vue';
import NotificationsSettings from '@/App/Logout/NotificationsSettings.vue';

import fetchJson from '../../src/dataRequest/fetch-json';


const props = defineProps({
  show: {
    type: Boolean,
    require: true,
  },
  login: {
    type: String,
    require: true,
  },
});

const emit = defineEmits(['close', 'toMonitoring', 'logout']);

const error = ref('');

const isAccordionClosed = ref({
  users: false,
  organizations: false,
});

const adminData = ref({});
const contractorsData = ref([]);
const showModal = ref('');
const editingOrganization = ref(false);
const isOrganizationObject = ref({
  partText: '',
  idPart: '',
  isOrganizationChecked: '',
});
const formInfo = ref('');
const userSearch = ref('');
const organizationSearch = ref('');
const isFullScreen = ref(false);
const editingMessengerRow = ref(null);
const isSavingMessenger = ref(false);

const userData = inject('userData');
const projectData = inject('projectData');

watch(
  () => props.show,
  async (show) => {
    if (show) {
      refreshHandler();
    }
  },
);

watch(adminData, (obj) => {
  if (obj.error) {
    error.value = obj.error;
    return;
  }

  if (Object.values(obj).length) {
    const isOrganization = obj.is_organization !== 'f';
    isOrganizationObject.value = {
      partText: isOrganization ? ' организации' : ' пользователя',
      idPart: isOrganization ? 'organization' : 'user',
      isOrganizationChecked: isOrganization ? 'checked' : '',
    };
  }

  const owners = () => {
    const organizations = adminData.value.organizationsData;
    const users = adminData.value.usersData;

    const owners = [];

    for (let key in organizations) {
      owners.push({
        value: organizations[key].line_id,
        login: organizations[key].login,
      });
    }

    for (let key in users) {
      if (users[key].role === 'user') continue;
      owners.push({
        value: users[key].line_id,
        login: users[key].login,
      });
    }

    return owners;
  };

  adminData.value.owners = owners();
});

const bothAccordionsOpen = computed(
  () => !isAccordionClosed.value.users && !isAccordionClosed.value.organizations,
);

const toggleAccordion = (name) => {
  isAccordionClosed.value[name] = !isAccordionClosed.value[name];
};

const showModalHandler = (str) => {
  showModal.value = str;
};

const logoutModalHandler = (str) => {
  if (str === 'toMonitoring') {
    emit(str);
    return;
  }
  fetch(
    `${
      process.env.VUE_APP_BACKEND_URL || window.location.origin + '/'
    }Api/auth/logout`,
    {
      credentials: 'include',
    },
  )
    .then((res) => res.json())
    .then((data) => {
      if (data['error']) {
        // error.value = data['error'];
        return;
      }
      if (data['redirectUrl'].includes('auth')) {
        emit('logout');
        error.value = '';

        showModalHandler('');
      }
    })
    .catch((rej) => {
      error.value =
        'Произошла ошибка. Попробуйте повторить запрос позже, либо перезагрузить страницу';
    })
    .finally(() => emit('logout'));
};

const editHandler = (lineObj) => {
  if (lineObj._messengerSettings) {
    delete lineObj._messengerSettings;
    editingMessengerRow.value = lineObj;
    showModalHandler('messenger-settings');
    return;
  }

  const owner = () => {
    let res = '';

    for (let owner of adminData.value.owners) {
      if (owner.login == lineObj.owner) {
        res = owner.value;
        break;
      }
    }

    return res;
  };
  
  editingOrganization.value = lineObj.isOrganization;

  adminData.value.post = {
    active: lineObj.active,
    description: lineObj.description,
    owner: owner(),
    id_contractor: lineObj.id_contractor,
    login: lineObj.login,
    name: lineObj.name,
    objects_mask: lineObj.objects_mask,
    psw: lineObj.psw,
    userRole: lineObj.role,
    templates: lineObj.templates,
    templates_names: lineObj.templates_names,
    template_time_intervals: lineObj.template_time_intervals,
    validity_time: lineObj.validity_time,
    validity_time_from: lineObj.validity_time_from,

    rule_fuel_watch: lineObj.rule_fuel_watch,
    rule_geofences_create: lineObj.rule_geofences_create,
    rule_geofences_delete: lineObj.rule_geofences_delete,
    rule_geofences_update: lineObj.rule_geofences_update,
    rule_geofences_watch: lineObj.rule_geofences_watch,
    rule_organizations_create: lineObj.rule_organizations_create,

    rule_contract_create: lineObj.rule_contract_create,
    rule_contract_delete: lineObj.rule_contract_delete,
    rule_contract_edit: lineObj.rule_contract_edit,
    rule_contract_watch: lineObj.rule_contract_watch,
    rule_contractor_create: lineObj.rule_contractor_create,
    rule_contractor_delete: lineObj.rule_contractor_delete,
    rule_contractor_edit: lineObj.rule_contractor_edit,
    rule_contractor_watch: lineObj.rule_contractor_watch,
    rule_vehicle_create: lineObj.rule_vehicle_create,
    rule_vehicle_delete: lineObj.rule_vehicle_delete,
    rule_vehicle_edit: lineObj.rule_vehicle_edit,
    rule_vehicle_watch: lineObj.rule_vehicle_watch,
    rule_manual_watch: lineObj.rule_manual_watch,
    rule_token1c_create: lineObj.rule_token1c_create,

    isOrganization: lineObj.isOrganization,
  };

  showModalHandler('edit-user');
};

const saveMessengerSettings = async () => {
  if (!editingMessengerRow.value?.messenger) return;

  isSavingMessenger.value = true;

  try {
    const fd = new FormData();
    fd.append('updateMode', 'on');
    fd.append('myLogin', editingMessengerRow.value.login);
    fd.append('isOrganization', 'on');
    fd.append('messenger', JSON.stringify(editingMessengerRow.value.messenger));

    const data = await fetchJson(
      `${
        process.env.VUE_APP_BACKEND_URL || window.location.origin + '/'
      }Api/users/administration`,
      {
        method: 'POST',
        body: fd,
      },
    );

    if (data.error) {
      console.error('Ошибка при сохранении настроек мессенджера:', data.error);
      return;
    }

    showModal.value = '';
    refreshHandler();
  } catch (error) {
    console.error('Ошибка при сохранении настроек мессенджера:', error);
  } finally {
    isSavingMessenger.value = false;
  }
};

const refreshHandler = async () => {
  adminData.value = {};
  showModal.value = '';
  formInfo.value = '';

  const res = await fetchJson(
    `${
      process.env.VUE_APP_BACKEND_URL || window.location.origin + '/'
    }Api/admin`,
  );
  try {
    const contractors = await fetchJson(
      `${
        process.env.VUE_APP_BACKEND_URL || window.location.origin + '/'
      }Api/manual/contractors`,
    );

    if (contractors.message && contractors.message.includes('недостаточно прав')) {
      contractorsData.value = [contractors.message];
    } else {
      contractorsData.value = contractors;
    }
    
  } catch (error) {
    contractorsData.value = [];
  }

  adminData.value = res;
};

const setFormInfo = (infoStr) => {
  formInfo.value = infoStr;
};

const toggleFullScreen = () => {
  isFullScreen.value = !isFullScreen.value;
};
</script>

<style lang="scss" scoped>
.large {
  height: 70vh !important;
}
.admin-content {
  flex-direction: column;
  height: 100%;
  min-height: 0;
}

.admin-content > .container-fluid {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
}

.admin-modal-window {
  /* min-width: 400px; */
  width: 95vw;
  /* min-height: 450px; */
  height: 95vh;
  margin: 25px auto;
  display: none;
  background: #fff;
  padding: 16px;
  z-index: 1003;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  @media screen and (max-width: 767px) {
    font-size: small;
  }
  @media screen and (max-width: 400px) {
    width: 100%;
  }

  &.full-screen {
    width: 100vw !important;
    height: 100vh !important;
    margin: 0 !important;
    left: 0 !important;
    right: 0 !important;
    top: 0 !important;
    bottom: 0 !important;
  }

  .accordion__title {
    border-bottom: 1px dashed #000;
  }
  .accordion__body {
    height: 320px;
    overflow: auto;
    transition: all 1s;
    &.closed {
      height: 0;
    }
  }
  & .my-m-2 {
    margin-left: 0.5rem;
    @media (max-width: 418px) {
      margin-left: 0;
      margin-top: 0.5rem;
    }
  }
  & .admin-table-wrapper {
    flex: 1;
    min-height: 400px;

    &.both-open {
      // flex-direction: column;

      // flex-wrap: nowrap;

      > [class*="col-"] {
        // flex: 1;
        // max-width: unset !important;

        // min-height: 0;
        // display: flex;
        // flex-direction: column;

        .my-toggle.accordion__body {
          height: 39vh !important;
          // height: auto;

          // flex: 1;
          // min-height: 0;
        }
      }
    }
    @media (max-width: 768px) {
      max-height: calc(80vh - 25px);
    }
    @media (max-width: 450px) {
      max-height: calc(70vh - 25px);
    }
  }
}

.messenger-settings-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1004;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow-y: auto;
}

.messenger-settings-modal {
  position: relative;
  background: #fff;
  border-radius: 12px;
  width: 80%;
  max-width: 900px;
  max-height: 85vh;
  display: flex;
  flex-direction: column;
}

.messenger-settings-modal__header {
  position: sticky;
  top: 0;
  z-index: 1;
  background: #fff;
  padding: 30px 30px 0;
}

.messenger-settings-modal__body {
  overflow-y: auto;
  padding: 0 30px;
}

.messenger-settings-modal__footer {
  position: sticky;
  bottom: 0;
  background: #fff;
  padding: 16px 30px 30px;
  border-radius: 0 0 12px 12px;
}
</style>
